/// <reference types="vite/client" />
const apiUrls = {
  customerPortal: {
    requestAccess: `${import.meta.env.VITE_API_URL}/api/customers/request-access`,
    authenticate: `${import.meta.env.VITE_API_URL}/api/customers/auth`,
    session: `${import.meta.env.VITE_API_URL}/api/customers/session`,
    logout: `${import.meta.env.VITE_API_URL}/api/customers/logout`,
    getStoreDetailsByDomain: `${import.meta.env.VITE_API_URL}/api/store/by-portal-domain`,
    account: `${import.meta.env.VITE_API_URL}/api/customers/portal/account`,
  },
  subscriptions: {
    byPortalCustomer: `${import.meta.env.VITE_API_URL}/api/customers/portal/subscriptions`,
  },
  orders: {
    byPortalCustomer: `${import.meta.env.VITE_API_URL}/api/customers/portal/orders`,
  },
};

export default apiUrls;
